export const END_RULE_TYPE = {
  relativeToVisit: 'relative_to_visit',
  afterNOccurrences: 'after_n_occurrences',
}

export const END_RULES_COMBINE = {
  none: 'none',
  earliestOf: 'earliest_of',
  latestOf: 'latest_of',
}

export const END_RULE_TYPE_LABELS = {
  [END_RULE_TYPE.relativeToVisit]: 'Relative to a visit',
  [END_RULE_TYPE.afterNOccurrences]: 'After N occurrences',
}

export const END_RULE_TYPE_OPTIONS = [
  { key: END_RULE_TYPE.relativeToVisit, text: END_RULE_TYPE_LABELS[END_RULE_TYPE.relativeToVisit] },
  { key: END_RULE_TYPE.afterNOccurrences, text: END_RULE_TYPE_LABELS[END_RULE_TYPE.afterNOccurrences] },
]

export const END_RULES_COMBINE_OPTIONS = [
  { key: END_RULES_COMBINE.earliestOf, text: 'Any anchor is reached' },
  { key: END_RULES_COMBINE.latestOf, text: 'All anchors are reached' },
]

export const END_OFFSET_UNIT_OPTIONS = [
  { key: 'weeks', text: 'weeks' },
  { key: 'days', text: 'days' },
  { key: 'hours', text: 'hours' },
  { key: 'minutes', text: 'minutes' },
]
